import { render } from "./TrainingsPage.vue?vue&type=template&id=5736d72e"
import script from "./TrainingsPage.vue?vue&type=script&lang=js"
export * from "./TrainingsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__